<template>
    <div ref="con">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name : "CloseOnOutsideClick",
    props : {
        elementThatOpensRef : {
            type : HTMLElement,
            required : true,
        },
        disabled : {
            type : Boolean,
            default : false,
        },
    },
    mounted () {
        window.addEventListener('click', this.close, { passive : true })
    },
    beforeDestroy () {
        window.removeEventListener('click', this.close);
    },
    methods : {
        close (event) {
            if(this.disabled ) {
                return;
            }
            if(!this.$refs.con.contains(event.target) && !this.elementThatOpensRef.contains(event.target)){
                this.$emit('close');
            }
        }
    },
}
</script>

<style scoped>

</style>
